import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState, useRecoilValue } from 'recoil';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';
import Select from 'pages/reference-implementation/components/select';
import { componentGroupsState, OrderPayload, urlParams } from 'pages/reference-implementation/provisioning/RI003AWS/store';
import { selectedEnv } from 'pages/reference-implementation/provisioning/RI003AWS/utils/constant';
import { InputLabel } from 'pages/reference-implementation/components/input-label';
import { getComponentsFromSchema } from '../../utils';

export const Sector = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const componentGroups = useRecoilValue(componentGroupsState);
    const [options, setOptions] = React.useState([]);
    const params = useRecoilValue(urlParams);
    const sectorApi = useMutation(() => axios.get(`${endPoints.aws.Ec2.awsSector}`));

    const setSector = (sector) => {
        setOrder({
            ...order,
            sector,
            department: null,
            departmentDetail: null,
            appRegion: null,
            appRegionDetail: null,
            environment: null,
            selectedDepartmentOption: null,
            division: null,
            program: null,
            resourceMgmt: {
                [selectedEnv]: {
                    components: getComponentsFromSchema({ componentGroups, particularPrompt: ['mandatoryComponents'] })?.[0]?.components || [],
                },
            },
        });
    };

    const seldValueExistsInOptions = (sectorValue) => options.find((option) => sectorValue === option?.value);

    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.value)) {
            setSector(selected?.value);
        }
    };

    React.useEffect(() => {
        if (sectorApi?.isSuccess) {
            if (sectorApi?.data?.data?.sectors)
                setOptions(
                    sectorApi?.data?.data?.sectors
                        ?.filter((app) => ['CMP', 'CGF'].includes(app?.sector))
                        ?.map((app) => ({ label: app?.sector, value: app?.sectorBackendName, data: app }))
                );
        }
    }, [sectorApi?.isSuccess]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.sector) {
            setOrder({ ...order, sector: options?.[0]?.value, sectorDetail: options?.[0]?.data });
        }
        if (options && options?.length && order?.sector) {
            const sector = seldValueExistsInOptions(order?.sector);
            if (sector) setOrder({ ...order, sector: sector?.value, sectorDetail: sector?.data });
        }
    }, [options]);

    React.useEffect(() => {
        sectorApi.mutate();
        // eslint-disable-next-line
    }, [order?.entityDetails?.sector]);

    React.useEffect(() => {
        if (!order?.sector && order?.isTouched) setIsTouched(true);
    }, [order?.sector, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                dataTestId="sector-auto"
                key="sector"
                label={<InputLabel label="Sector" isRequired />}
                value={order?.sector || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={sectorApi.isLoading || params?.journeyId}
                isLoading={sectorApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(Sector);
